import polyglotI18nProvider from 'ra-i18n-polyglot';
import { polishMessages } from './polishMessages';

/**
 * Jeden język: polski. Przełącznik PL/EN/DE z FF (CustomAppBar) wymaga
 * słowników dla naszych etykiet, które dziś są wpisane po polsku w kodzie —
 * to osobna decyzja, nie efekt uboczny tłumaczenia react-admina.
 *
 * `allowMissing` — brakujący klucz (np. z nowszej wersji react-admina)
 * pokazuje sam klucz zamiast wywrócić ekran; test słownika pilnuje, żeby
 * takich nie było.
 */
export const i18nProvider = polyglotI18nProvider(() => polishMessages, 'pl', [{ locale: 'pl', name: 'Polski' }], {
  allowMissing: true,
});
